module.exports = __webpack_public_path__ + "static/media/Existing_Brand_Profiles.6065c50d.svg";